import { request } from '~/agent';

export const getNotes = (objectTypeID, objectID, params) => {
	return request.get(`notes/${objectTypeID}/${objectID}`, params);
};

export const getNote = noteID => {
	return request.get(`notes/${noteID}`);
};

export const pinNote = (noteID, data, params) => {
	return request.post(`notes/${noteID}/pin`, data, params);
};

export const searchNote = noteID => {
	return request.get(`notes/${noteID}`);
};

export const updateNote = (id, data, params) => {
	if (id) {
		return request.post(`notes/${id}`, data, params);
	}

	return request.post(`notes`, data, params);
};

export const deleteNote = id => {
	return request.del(`notes/${id}`);
};

export const shareNoteWithOwner = (id, data, params) => {
	return request.post(`notes/${id}/share/owner`, data, params);
};

export const shareNoteWithTenant = (id, data, params) => {
	return request.post(`notes/${id}/share/tenant`, data, params);
};

export const shareNoteWithVendor = (id, data, params) => {
	return request.post(`notes/${id}/share/vendor`, data, params);
};

// Files
export const getFiles = params => {
	return request.get(`files`, params);
};

export const getAttachedFiles = (objectTypeID, objectID, params) => {
	return request.get(`files/attachments/${objectTypeID}/${objectID}`, params);
};

export const getUnattachedFiles = (objectTypeID, objectID, params) => {
	return request.get(`files/unattached/${objectTypeID}/${objectID}`, params);
};

export const attachFile = (id, objectTypeID, objectID) => {
	return request.post(`files/${id}/attach/${objectTypeID}/${objectID}`);
};

export const uploadFile = (file, params, config) => {
	return request.upload('files', null, file, params, config);
};

export const getFile = id => {
	return request.get(`files/${id}`);
};

export const updateFile = (id, data, params) => {
	return request.post(`files/${id}`, data, params);
};

export const downloadFile = id => {
	return request.download(`files/${id}/download`);
};

export const downloadMultipleFiles = data => {
	return request.download(`files/download/multi`, null, data, 'POST');
};

export const previewFile = id => {
	return request.get(`files/${id}/preview`);
};

export const deleteFile = id => {
	return request.del(`files/${id}`);
};

export const deleteFileAttachment = id => {
	return request.del(`files/attachments/${id}`);
};

export const shareFileWithTenant = (id, data, params) => {
	return request.post(`files/attachments/${id}/set-tenant-shared`, data, params);
};

export const shareFileWithOwner = (id, data, params) => {
	return request.post(`files/attachments/${id}/set-owner-shared`, data, params);
};

export const shareFileWithVendor = (id, data, params) => {
	return request.post(`files/attachments/${id}/set-vendor-shared`, data, params);
};

export const getAlerts = (objectTypeID, objectID, qs) => {
	return request.get(`alerts/${objectTypeID}/${objectID}`, qs);
};

export const getSharedAlert = (objectTypeID, objectID, alertShareObjectTypeID) => {
	return request.get(`alerts/shared/${objectTypeID}/${objectID}/${alertShareObjectTypeID}`);
};

export const updateAlert = (id, data, params) => {
	if (id) {
		return request.post(`alerts/${id}`, data, params);
	}

	return request.post(`alerts`, data, params);
};

export const deleteAlert = id => {
	return request.del(`alerts/${id}`);
};

// delete multiple files
export const deleteMultipleFiles = (data, params) => {
	return request.del(`files/attachments/delete/multi`, params, data);
};

// Used for tiptap mentions
export const getUsers = params => {
	return request.get(`users`, params);
};

// Used for tiptap snippets
export const getSnippets = params => {
	return request.get(`snippets`, params);
};
